import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { Intersection } from "@splidejs/splide-extension-intersection";
import "@splidejs/splide/dist/css/splide.min.css";
import { useRef } from "react";
import IconQuote from "./components/IconQuote";
import styles from "./Section8.module.scss";

const testimonials = [
  {
    quote:
      "After working with a career counselor, I learned that I wanted to work in cyber. The impact is that it led me to this position where I can utilize my engineering skills with Python in the cybersecurity field.",
    author: "Bruce R.",
  },
  {
    quote: "The course definitely got me on the right track toward cybersecurity success.",
    author: "Ryan M.",
  },
  {
    quote:
      "I chose to get a jumpstart on changing careers. The new skill sets I’ve gained from the course have had immeasurable results.",
    author: "Ian M.",
  },
];

export const Section8 = function () {
  const carousel_options = {
    type: "loop",
    autoplay: true,
    interval: 10000,
    mediaQuery: "min",
    perMove: 1,
    gap: 40,
    flickMaxPages: 1,
    updateOnMove: true,
    trimSpace: "move",
    slideFocus: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    waitForTransition: false,
    releaseWheel: true,
    autoHeight: true,
    pagination: false,
    arrows: true,
    drag: false,
    resetProgress: false,
    breakpoints: {
      320: {
        perPage: 1,
      },
      768: {
        perPage: 2,
        focus: 1,
        gap: 40,
      },
      992: {
        perPage: 3,
        focus: "center",
        gap: 60,
      },
    },
  };

  const refTestimonials = useRef(null);

  return (
    <section className={`${styles.container} cc--component-container`} id="testimonials">
      <div className={styles.content}>
        <span className={`${styles.headline} title`}>What Boot Camp Learners Are Saying</span>
        <div className={styles.testimonials}>
          <Splide
            ref={refTestimonials}
            className={styles.splide_carousel}
            options={carousel_options}
            hasTrack={false}
            extensions={{ Intersection }}
            onResized={(splide) => {
              const isSmallScreen = window.innerWidth < 992;
              const { play, pause } = splide.Components.Autoplay;
              isSmallScreen ? play() : pause();
            }}
          >
            <SplideTrack>
              {testimonials.map(({ quote, author }, index) => (
                <SplideSlide key={quote} className={styles.testimonial}>
                  <IconQuote />
                  <span className={styles.quote}>“{quote}”</span>
                  <strong className={styles.author}>&mdash; {author}</strong>
                </SplideSlide>
              ))}
            </SplideTrack>
          </Splide>
        </div>
      </div>
    </section>
  );
};
